import React from "react";
import "./index.css";
import ProductContainer from "./productContainer";

function Products(props) {
  return (
    <div className="table-container">
      <ProductContainer />
    </div>
  );
}

export default Products;
